import React from "react";
import "./style/footer.css";
import footerLogo from './assets/footer-logo.png';
import { AiOutlineX } from "react-icons/ai";
import fbIcon from './assets/icons/fb_icon.svg'
import instaIcon from './assets/icons/insta_icon.svg'
import linkedIcon from './assets/icons/linkedin_icon.svg';
import instaMobIcon from './assets/icons/insta_mob_icon.svg';
import twitterMobIcon from './assets/icons/twitter_mob_icon.svg';

export default function Footer() {
    return (
        <footer className="bg-white">
            <div className="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
                <div className="md:flex md:justify-between">

                    <div className="mb-6 md:mb-0">
                        <div className="mb-6">
                            <img src={footerLogo} alt="Top Agent Pro" className="lg:h-42 lg:w-32  md:h-22 md:w-16 sm:h-22 sm:w-16" />
                            <p style={{ visibility: "hidden" }} className="text-sm text-gray-500 leading-relaxed mt-2 text-left">
                                We are a real estate agency that will help  you find the best residence you dream!
                            </p>
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-4">

                        <div>
                            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase">
                                Company
                            </h2>
                            <ul className="text-gray-700 font-medium">
                                <li className="mb-4">
                                    <a href="#" className="hover:underline">
                                        About Us
                                    </a>
                                </li>
                                <li className="mb-4">
                                    <a href="#" className="hover:underline">
                                        Contact
                                    </a>
                                </li>
                                <li className="mb-4">
                                    <a href="#" className="hover:underline">
                                        Career
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className="hover:underline">
                                        Blog
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div>
                            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase">
                                Contact Us
                            </h2>
                            <ul className="text-gray-700 font-medium">
                                <li className="mb-4">
                                    <a href="#" className="hover:underline">
                                        Website
                                    </a>
                                </li>
                                <li className="mb-4">
                                    <a href="#" className="hover:underline">
                                        Email
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className="hover:underline">
                                        WhatsApp
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div>
                            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase">
                                Support
                            </h2>
                            <ul className="text-gray-700 font-medium">
                                <li className="mb-4">
                                    <a href="#" className="hover:underline">
                                        FAQ
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className="hover:underline">
                                        Booking
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className="hover:underline">
                                        City Guide
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className="hover:underline">
                                        Cancellation Option
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div>
                            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase">
                                Office
                            </h2>
                            <ul className="text-gray-500 font-medium">
                                <li className="mb-2">Headquartered in Silicon Valley, CA (Remote Team)</li>
                                
                            </ul>
                        </div>
                    </div>
                </div>
                <hr className="my-6 border-gray-200 sm:mx-auto lg:my-8" />

                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">

                    <span className="text-md  block sm:hidden">Follow Us</span>
                    <br></br>
                    <div className="flex items-center space-x-4 mb-4  sm:mb-0 sm:hidden flex-nowrap">

                        <a href="#" aria-label="Instagram" className="text-gray-500 hover:text-gray-900 dark:hover:text-white">


                            <img src={linkedIcon} alt="" className="w-7 h-7 mt-1 flex-shrink-0" />

                        </a>
                        <a href="#" aria-label="Facebook" className="text-gray-500 hover:text-gray-900 dark:hover:text-white">


                            <img src={instaMobIcon} alt="" className="w-7 h-7 mt-1 flex-shrink-0" />

                        </a>
                        <a href="#" aria-label="X (Twitter)" className="text-gray-500 hover:text-gray-900 dark:hover:text-white">

                            <img src={twitterMobIcon} alt="" className="w-7 h-7 mt-1 flex-shrink-0" />


                        </a>
                    </div>


                    <span className="text-sm my-3 text-gray-900 sm:text-gray-500 text-center sm:text-left sm:flex-1">
                        © 2025 Top Agent Pro - All Rights Reserved
                    </span>

                    <div className="hidden sm:flex space-x-6">
                        <a href="#" aria-label="Instagram" className="text-gray-500 hover:text-gray-900 dark:hover:text-white">

                            <img src={instaIcon} alt="" className="w-9 h-9 mt-1 flex-shrink-0" />
                        </a>
                        <a href="#" aria-label="Facebook" className="text-gray-500 hover:text-gray-900 dark:hover:text-white">


                            <img src={fbIcon} alt="" className="w-9 h-9 mt-1 flex-shrink-0" />
                        </a>
                        <a href="#" aria-label="X (Twitter)" className="text-gray-500 hover:text-gray-900 dark:hover:text-white">

                            <AiOutlineX className="w-7 h-7 mt-2" />
                        </a>
                    </div>
                </div>


            </div>
        </footer>
    );
}
